import { render, staticRenderFns } from "./Percepciones.vue?vue&type=template&id=4ecf6dde&"
import script from "./Percepciones.vue?vue&type=script&lang=js&"
export * from "./Percepciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports